<template>
  <div>
    <header class="header fixed-header content">
      <img class="vip-logo" src="@assets/promotion/vip-logo.png" alt="logo" />
      <div
        class="header-item"
        :class="{'header-active': routeName === 'promotion'}"
        @click="redirect('promotion')">
        商务合作
      </div>
      <div
        class="header-item"
        :class="{'header-active': routeName === 'promotion-document'}"
        @click="redirect('promotion-document')">
        文档中心
      </div>
      <div
        class="header-item"
        :class="{'header-active': routeName === 'promotion-business'}"
        @click="redirect('promotion-business')">
        联系我们
      </div>
      <div
        class="header-item"
        :class="{'header-active': routeName === 'wholesale'}"
        @click="redirect('wholesale')">
        代购批发
      </div>
    </header>
    <div class="header"></div>
  </div>
</template>

<script>
export default {
  name: 'PromotionHeader',
  data() {
    return {
      routeName: 'promotion',
    }
  },
  mounted() {
    this.routeName = this.$route.name
  },
  methods: {
    redirect(name) {
      if (name === this.routeName) return
      this.$router.replace({
        name
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.content {
  min-width: 900rem;
}
.header {
  width: 100%;
  height: 80rem;
  display: flex;
  align-items: center;
  padding-left: 12.5vw;
  box-sizing: border-box;
  background: #fff;
  border-bottom: 2rem solid #EBEBEB;

  .vip-logo {
    width: 129rem;
    height: 58rem;
    margin-right: 90rem;
    cursor: pointer;
  }
  .header-item {
    width: 130rem;
    height: 80rem;
    line-height: 80rem;
    text-align: center;
    color: #333;
    font-size: 24rem;
    margin-right: 15rem;
    cursor: pointer;
    border-bottom: 4rem solid #fff;
    box-sizing: border-box;
  }
  .header-active {
    color: #E4007F;
    border-color: #F90080;
  }
}
.fixed-header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
}
</style>


// WEBPACK FOOTER //
// src/components/PromotionHeader.vue